import { apiClient } from '../apiClient';

export const PATHS = {
  LEGAL_DOCUMENTS: '/api/v1/legal-documents/',
} as const;

export type LegalDocument = {
  uuid: string;
  key: string;
  name: string;
  documentUrl: string;
  needToSign: boolean;
  displayAgree: boolean;
  checkboxGroup: number;
  order: number;
  additionalLanguage: string | null;
};

export type LegalDocumentsResponse = {
  documents: LegalDocument[];
  needToSign: boolean;
};

export async function fetchLegalDocuments(): Promise<LegalDocumentsResponse> {
  const res = await apiClient.get<LegalDocumentsResponse>(PATHS.LEGAL_DOCUMENTS);
  return res.data;
}
